//@flow
import React, {useState, useEffect} from 'react';
import {Alert} from '@material-ui/lab';
import {makeStyles} from '@material-ui/core';
import type {AlertProps} from '@material-ui/lab';

type Props = {
  open?: boolean,
  onClose?: () => void,
  closeDelay?: number,
} & AlertProps;

const useStyles = makeStyles(theme => ({
  alertContainer: {
    position: 'fixed',
    bottom: '1.5rem',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 9999,
  },
}));

export default function Toast(props: Props) {
  const {open, onClose, closeDelay = 2000, ...alertProps} = props;

  const classes = useStyles();

  const [_open, _setOpen] = useState(open);

  useEffect(() => {
    _setOpen(open);
  }, [open]);

  useEffect(() => {
    if (!_open) return;
    const timer = setTimeout(() => {
      _setOpen(false);
      onClose && onClose();
    }, closeDelay);
    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_open, closeDelay]);

  if (!_open) return null;

  return (
    <div className={classes.alertContainer}>
      <Alert {...alertProps} />
    </div>
  );
}
